"use client";

import { QueryResponseInitial, useQuery } from "@sanity/react-loader";
import { SanityDocument } from "next-sanity";

import { marketsBySlugQuery } from '@otomoro/sanity/lib/queries/markets/marketsBySlug.groq'
import MarketPage from "./MarketPage";

export default function MarketPagePreview({
  initial,
	slug,
}: {
  initial: QueryResponseInitial<SanityDocument[]>;
	slug: string
}) {
	const { data } = useQuery<SanityDocument[] | null>(
    marketsBySlugQuery,
    {
			slug
		},
    { initial }
  );

	return data ? (
    <MarketPage data={data as any} />
  ) : (
    <div className="bg-red-100">No posts found</div>
  );
}
